import React from "react";
import Header from "../components/Header";
import Hero from "../components/Hero";
import About from "../components/About";
import Members from "../components/Members";
import Influences from "../components/Influences";
import Shows from "../components/Shows";
import News from "../components/News";
import Booking from "../components/Booking";
import Footer from "../components/Footer";

const HomePage = () => {
  return (
    <div className="min-h-screen bg-black">
      <Header />
      <Hero />
      <About />
      <Members />
      <Influences />
      <Shows />
      <News />
      <Booking />
      <Footer />
    </div>
  );
};

export default HomePage;
